(function () {
  var timerEl = document.getElementById('countdown-timer');
  if (!timerEl) return;

  var targetValue = timerEl.getAttribute('data-target');
  if (!targetValue) return;

  var target = new Date(targetValue + 'T00:00:00');
  var daysEl = document.getElementById('days');
  var hoursEl = document.getElementById('hours');
  var minutesEl = document.getElementById('minutes');
  var secondsEl = document.getElementById('seconds');

  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function updateCountdown() {
    var diff = target - new Date();

    if (diff <= 0) {
      daysEl.textContent = '00';
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
      return;
    }

    daysEl.textContent = pad(Math.floor(diff / 86400000));
    hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
    minutesEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
    secondsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
})();
